import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-be189e24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tenant-color-dropdown" }
const _hoisted_2 = { class: "color-picker-content" }
const _hoisted_3 = { class: "color-picker-header" }
const _hoisted_4 = { class: "color-title" }
const _hoisted_5 = { class: "color-grid" }
const _hoisted_6 = ["title", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "check-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z",
  fill: "white"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.Localizer.Localize('Select_a_color')), 1),
        _createVNode(_component_f_button, {
          type: "text",
          onClick: _ctx.resetColor,
          class: "refresh-button",
          title: _ctx.Localizer.Localize('Header_Reset'),
          outline: false,
          focus: false,
          bordered: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_f_icon, {
              icon: "refresh",
              size: 16
            })
          ]),
          _: 1
        }, 8, ["onClick", "title"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorPalette, (color) => {
          return (_openBlock(), _createElementBlock("div", {
            key: color.name,
            class: _normalizeClass(["color-swatch", { 'selected': _ctx.isSelectedColor(color) }]),
            title: color.name,
            onClick: ($event: any) => (_ctx.selectColor(color))
          }, [
            _createElementVNode("div", {
              class: "color-swatch-inner-box",
              style: _normalizeStyle({ backgroundColor: color.value })
            }, [
              (_ctx.isSelectedColor(color))
                ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
                : _createCommentVNode("", true)
            ], 4)
          ], 10, _hoisted_6))
        }), 128))
      ])
    ])
  ]))
}